import React from "react";
import "./MicAnimation.css";

export default function MicAnimation() {
  return (
    <div className="mic-container">
      <div className="bars">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <svg
        className="mic-icon"
        viewBox="0 0 24 24"
        fill="currentColor"
        width="24"
        height="24"
      >
        <path d="M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3zm5 9a5 5 0 0 1-10 0H5a7 7 0 0 0 14 0h-2z"/>
      </svg>
    </div>
  );
} 